import UAParser from 'ua-parser-js'

userDeviceTable.$inject = ['$window', 'auth', 'ipToLocation']

export default function userDeviceTable($window, auth, ipToLocation) {
  return {
    restrict: 'EA',
    scope: {
      userDeviceReport: '=userDeviceReport',
      refreshFn: '&refresh'
    },
    link: function(scope) {
      var parser = new UAParser()
      function toFriendlyUA(rawUA) {
        parser.setUA(rawUA)
        var res = parser.getResult()

        var parsedUa = {
          browser: `${res.browser.name} (v${res.browser.major})`,
          os: `${res.os.name} (v${res.os.version})`,
          device:
            (
              `${res.device.vendor || ''} ` +
              `${res.device.model || ''} ` +
              `${res.device.type || ''}`
            ).trim() || 'Unknown Device'
        }

        var iconClass
        switch (res.device.type) {
          case 'mobile':
            iconClass = 'mobile'
            break
          case 'tablet':
            iconClass = 'tablet'
            break
          case 'smarttv':
            iconClass = 'television'
            break
          case 'wearable':
          case 'embedded':
          case 'console':
            iconClass = 'question'
            break
          default:
            iconClass = 'laptop'
            break
        }

        return `<i class="fa fa-${iconClass}" aria-hidden="true"></i> ${parsedUa.device} &middot; ${
          parsedUa.os
        } &middot; ${parsedUa.browser}`
      }

      scope.clearSession = async function({ user_uuid, session_id }) {
        try {
          let results = await auth.clearUserSessions(user_uuid, session_id)
          if (results[session_id].cleared) {
            $window.alert(`Session ${session_id} cleared.`)
            scope.refreshFn && scope.refreshFn()
          }
        } catch (err) {
          $window.alert(`Error clearing session: ${JSON.stringify(err)}`)
        }
      }

      scope.$watch('userDeviceReport', function(reps) {
        console.log(reps)
        reps = reps || []

        scope.collapseMap = {}

        reps = reps.map(function(r) {
          r.friendly_ua = toFriendlyUA(r.latest_user_agent)
          return r
        })

        var ipToIndices = {}
        reps.forEach(function(r, idx) {
          scope.collapseMap[r.session_id] = !scope.isActive(r)
          if (!r.latest_ip) {
            return
          }
          ipToIndices[r.latest_ip] = ipToIndices[r.latest_ip] || []
          ipToIndices[r.latest_ip].push(idx)
        })

        for (const ip in ipToIndices) {
          ipToLocation.getIpLocation(ip).then(
            function(res) {
              ipToIndices[res.ip].forEach(function(ipIdx) {
                reps[ipIdx].latest_location = res.location
              })
            },
            function(err) {
              ipToIndices[err.ip].forEach(function(ipIdx) {
                reps[ipIdx].latest_location_error = err.message
              })
            }
          )
        }
      })

      scope.isActive = function(session) {
        return session.session_ended_at == '0001-01-01T00:00:00Z'
      }
    },
    template: require('./_userDevicesTable.html')
  }
}
